var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.792 10a1.042 1.042 0 00-1.042-1.042h-7.5a1.042 1.042 0 000 2.084h7.5A1.042 1.042 0 0014.792 10zM10 12.708a1.042 1.042 0 00-1.042 1.041v1.875a.208.208 0 01-.208.209H7.5a.833.833 0 00-.59 1.422l2.5 2.5a.833.833 0 001.18 0l2.5-2.5a.833.833 0 00-.59-1.422h-1.25a.208.208 0 01-.208-.208V13.75A1.042 1.042 0 0010 12.708zM10.59.243a.833.833 0 00-1.18 0l-2.5 2.5a.833.833 0 00.59 1.424h1.25a.208.208 0 01.208.208V6.25a1.042 1.042 0 002.084 0V4.374a.208.208 0 01.208-.207h1.25a.833.833 0 00.59-1.423z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.05effb71.svg";
export { ForwardRef as ReactComponent };